module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Eco Nabuk_LT Grey.d1c0da6d.png";